<app-wizard
  (finish)='onWizardFinish($event)'
  [showButtons]='false'
  [steps]='wizardSteps'></app-wizard>